import React, { Component } from 'react';

import './App.css';
import { mobile } from './question/mobile';
import ProjectWizardBase from './projectwizard-base';

const ProjectWizard = props => {
  console.warn(props.setAvailable);
  return <ProjectWizardBase questions={mobile} />;
};

export default ProjectWizard;
